import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  static integer(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const value = Number(control.value);
    return Number.isInteger(value) ? null : { integer: true };
  }

  static isoE164(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const isoE164Regex = /^\+[1-9]\d{1,14}$/;

    return isoE164Regex.test(control.value) ? null : { isoE164: true };
  }

  static url(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    try {
      const parsed = new URL(String(control.value));
      return ['http:', 'https:'].includes(parsed.protocol) ? null : { url: true };
    } catch (e) {
      return { url: true };
    }
  }

  static countryCode(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const countryCodeRegex = /^[A-Za-z]{2}$/;
    return countryCodeRegex.test(control.value) ? null : {countryCode: true};
  }
}
